import { Injectable } from '@angular/core';
import { GenericRequestHandlerService } from '../../core/services/generic-request-handler.service';
import { MyLibraryService } from '../../api';

@Injectable({
    providedIn: 'root'
})
export class MyDocumentsService {

    constructor(
        private genericRequestHandler: GenericRequestHandlerService,
        private api: MyLibraryService
    ) { }

    public removeFile(fileId) {
        return this.genericRequestHandler.callRequest(
            this.api.deleteMyDocumentHandler(fileId),
            'Plik został usunięty'
        );
    }

    public saveFile(content) {
        return this.genericRequestHandler.callRequest(
            this.api.createMyDocumentHandler(content),
            'Dokumenty dodane'
        );
    }
}
